import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbFavorites } from '../../interfaces/eb-favorites.interface'

export const EB_FAVORITES_NORMALIZER = new InjectionToken<Converter<any, EbFavorites>>(
  'EbFavoritesNormalizer'
)
